import { roles } from 'utils/auth'
import applyMeta from './apply-meta'
import MainTemplate from 'templates/MainTemplate'
import DeliveryRunsPending from 'views/delivery-runs/Pending'
import RunSheets from 'views/delivery-runs/RunSheets'
import RunSheet from 'views/delivery-runs/RunSheet'
import RunSheetDriver from 'views/delivery-runs/RunSheetDriver'
import PrintLogs from 'views/print-logs/PrintLogs'

export default [
  {
    path: '/',
    beforeEnter (to, from, next) {
      window.location.href = process.env.VUE_APP_API_URL
    }
  },

  // logged in pages
  ...applyMeta({ requiresAuth: true, template: MainTemplate }, [
    {
      path: '/delivery-runs/pending',
      name: 'delivery-runs.pending',
      component: DeliveryRunsPending,
      meta: {
        access: [roles.ADMIN]
      }
    },
    {
      path: '/delivery-runs/run-sheets',
      name: 'delivery-runs.run-sheets',
      component: RunSheets,
      meta: {
        access: [roles.ADMIN]
      }
    },
    {
      path: '/delivery-runs/run-sheets/:id',
      props: true,
      name: 'delivery-runs.run-sheet',
      component: RunSheet,
      meta: {
        access: [roles.ADMIN]
      }
    },
    {
      path: '/delivery-runs/run-sheets/:id/driver/:stopId?',
      props: true,
      name: 'delivery-runs.run-sheet.stop',
      component: RunSheetDriver,
      meta: {
        access: [roles.ADMIN]
      }
    },
    {
      path: '/print-history',
      name: 'print-history',
      component: PrintLogs,
      meta: {
        access: [roles.ADMIN]
      }
    }
  ])
]
